const Hands = () => {
  return <h2>I'm Hands</h2>
}

export default Hands